export const CONTRAS_RESET_STATE = 'CONTRAS_RESET_STATE';
export const CONTRAS_CURRENT_ITEM = 'CONTRAS_CURRENT_ITEM';

export const CONTRAS_REQUEST_LOADING = 'CONTRAS_REQUEST_LOADING';
export const CONTRAS_REQUEST_SUCCESS = 'CONTRAS_REQUEST_SUCCESS';
export const CONTRAS_REQUEST_FAILED = 'CONTRAS_REQUEST_FAILED';

export const CONTRAS_CURRENT_ACTION = 'CONTRAS_CURRENT_ACTION';
export const CONTRAS_RESET_ACTION = 'CONTRAS_RESET_ACTION';